module.exports = __webpack_public_path__ + "static/media/range.b50f342b.svg";